var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cotacnt-form-contact"},[_c('h2',[_vm._v("お問い合わせ")]),_c('UiLine')],1)}
var staticRenderFns = []

export { render, staticRenderFns }